import React from "react";
import { Card, Empty, Space, Row, Col } from "antd";
import RequestViewer from "../../components/RequestViewer";
import { useRequest } from "../../hooks/useRequest";
import PageHeader from "../../components/common/PageHeader";

/**
 * Página de monitoramento de requisições (CW1).
 *
 * Exibe todas as requisições que estão sendo monitoradas.
 */
const RequestMonitoringContent: React.FC = () => {
  const { requests } = useRequest();

  return (
    <Card>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <PageHeader title="Monitoramento de Requisições" />

        {requests.length === 0 ? (
          <Empty description="Nenhuma requisição sendo monitorada. Volte para a página de Requisições para adicionar." image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <Row gutter={[16, 16]}>
            {requests.map((requestId, idx) => (
              <Col xs={24} sm={24} md={12} lg={12} xl={12} key={idx}>
                <RequestViewer requestId={requestId} />
              </Col>
            ))}
          </Row>
        )}
      </Space>
    </Card>
  );
};

/**
 * Componente principal da página RequestMonitoring.
 */
const RequestMonitoring: React.FC = () => {
  return (
    <RequestMonitoringContent />
  );
};

export default RequestMonitoring;
